//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
//                                                    //
//       THIS FILE IS AUTOGENERATED!!!!               //
//                 Do not edit.                       //
//                                                    //
//    Generator is in scripts/generateLocales         //
//                                                    //
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
export function loadMomentWithTzAndLocale(locale: string) {
  if (locale === 'en') {
    return loadMomentWithTz();
  }
  const locales = {
    af: loadMomentWithTzAndLocaleAf,
    'ar-dz': loadMomentWithTzAndLocaleArDz,
    'ar-kw': loadMomentWithTzAndLocaleArKw,
    'ar-ly': loadMomentWithTzAndLocaleArLy,
    'ar-ma': loadMomentWithTzAndLocaleArMa,
    'ar-sa': loadMomentWithTzAndLocaleArSa,
    'ar-tn': loadMomentWithTzAndLocaleArTn,
    ar: loadMomentWithTzAndLocaleAr,
    az: loadMomentWithTzAndLocaleAz,
    be: loadMomentWithTzAndLocaleBe,
    bg: loadMomentWithTzAndLocaleBg,
    bm: loadMomentWithTzAndLocaleBm,
    'bn-bd': loadMomentWithTzAndLocaleBnBd,
    bn: loadMomentWithTzAndLocaleBn,
    bo: loadMomentWithTzAndLocaleBo,
    br: loadMomentWithTzAndLocaleBr,
    bs: loadMomentWithTzAndLocaleBs,
    ca: loadMomentWithTzAndLocaleCa,
    cs: loadMomentWithTzAndLocaleCs,
    cv: loadMomentWithTzAndLocaleCv,
    cy: loadMomentWithTzAndLocaleCy,
    da: loadMomentWithTzAndLocaleDa,
    'de-at': loadMomentWithTzAndLocaleDeAt,
    'de-ch': loadMomentWithTzAndLocaleDeCh,
    de: loadMomentWithTzAndLocaleDe,
    dv: loadMomentWithTzAndLocaleDv,
    el: loadMomentWithTzAndLocaleEl,
    'en-au': loadMomentWithTzAndLocaleEnAu,
    'en-ca': loadMomentWithTzAndLocaleEnCa,
    'en-gb': loadMomentWithTzAndLocaleEnGb,
    'en-ie': loadMomentWithTzAndLocaleEnIe,
    'en-il': loadMomentWithTzAndLocaleEnIl,
    'en-in': loadMomentWithTzAndLocaleEnIn,
    'en-nz': loadMomentWithTzAndLocaleEnNz,
    'en-sg': loadMomentWithTzAndLocaleEnSg,
    eo: loadMomentWithTzAndLocaleEo,
    'es-do': loadMomentWithTzAndLocaleEsDo,
    'es-mx': loadMomentWithTzAndLocaleEsMx,
    'es-us': loadMomentWithTzAndLocaleEsUs,
    es: loadMomentWithTzAndLocaleEs,
    et: loadMomentWithTzAndLocaleEt,
    eu: loadMomentWithTzAndLocaleEu,
    fa: loadMomentWithTzAndLocaleFa,
    fi: loadMomentWithTzAndLocaleFi,
    fil: loadMomentWithTzAndLocaleFil,
    fo: loadMomentWithTzAndLocaleFo,
    'fr-ca': loadMomentWithTzAndLocaleFrCa,
    'fr-ch': loadMomentWithTzAndLocaleFrCh,
    fr: loadMomentWithTzAndLocaleFr,
    fy: loadMomentWithTzAndLocaleFy,
    ga: loadMomentWithTzAndLocaleGa,
    gd: loadMomentWithTzAndLocaleGd,
    gl: loadMomentWithTzAndLocaleGl,
    'gom-deva': loadMomentWithTzAndLocaleGomDeva,
    'gom-latn': loadMomentWithTzAndLocaleGomLatn,
    gu: loadMomentWithTzAndLocaleGu,
    he: loadMomentWithTzAndLocaleHe,
    hi: loadMomentWithTzAndLocaleHi,
    hr: loadMomentWithTzAndLocaleHr,
    hu: loadMomentWithTzAndLocaleHu,
    'hy-am': loadMomentWithTzAndLocaleHyAm,
    id: loadMomentWithTzAndLocaleId,
    is: loadMomentWithTzAndLocaleIs,
    'it-ch': loadMomentWithTzAndLocaleItCh,
    it: loadMomentWithTzAndLocaleIt,
    ja: loadMomentWithTzAndLocaleJa,
    jv: loadMomentWithTzAndLocaleJv,
    ka: loadMomentWithTzAndLocaleKa,
    kk: loadMomentWithTzAndLocaleKk,
    km: loadMomentWithTzAndLocaleKm,
    kn: loadMomentWithTzAndLocaleKn,
    ko: loadMomentWithTzAndLocaleKo,
    ku: loadMomentWithTzAndLocaleKu,
    ky: loadMomentWithTzAndLocaleKy,
    lb: loadMomentWithTzAndLocaleLb,
    lo: loadMomentWithTzAndLocaleLo,
    lt: loadMomentWithTzAndLocaleLt,
    lv: loadMomentWithTzAndLocaleLv,
    me: loadMomentWithTzAndLocaleMe,
    mi: loadMomentWithTzAndLocaleMi,
    mk: loadMomentWithTzAndLocaleMk,
    ml: loadMomentWithTzAndLocaleMl,
    mn: loadMomentWithTzAndLocaleMn,
    mr: loadMomentWithTzAndLocaleMr,
    'ms-my': loadMomentWithTzAndLocaleMsMy,
    ms: loadMomentWithTzAndLocaleMs,
    mt: loadMomentWithTzAndLocaleMt,
    my: loadMomentWithTzAndLocaleMy,
    nb: loadMomentWithTzAndLocaleNb,
    ne: loadMomentWithTzAndLocaleNe,
    'nl-be': loadMomentWithTzAndLocaleNlBe,
    nl: loadMomentWithTzAndLocaleNl,
    nn: loadMomentWithTzAndLocaleNn,
    'oc-lnc': loadMomentWithTzAndLocaleOcLnc,
    'pa-in': loadMomentWithTzAndLocalePaIn,
    pl: loadMomentWithTzAndLocalePl,
    'pt-br': loadMomentWithTzAndLocalePtBr,
    pt: loadMomentWithTzAndLocalePt,
    ro: loadMomentWithTzAndLocaleRo,
    ru: loadMomentWithTzAndLocaleRu,
    sd: loadMomentWithTzAndLocaleSd,
    se: loadMomentWithTzAndLocaleSe,
    si: loadMomentWithTzAndLocaleSi,
    sk: loadMomentWithTzAndLocaleSk,
    sl: loadMomentWithTzAndLocaleSl,
    sq: loadMomentWithTzAndLocaleSq,
    'sr-cyrl': loadMomentWithTzAndLocaleSrCyrl,
    sr: loadMomentWithTzAndLocaleSr,
    ss: loadMomentWithTzAndLocaleSs,
    sv: loadMomentWithTzAndLocaleSv,
    sw: loadMomentWithTzAndLocaleSw,
    ta: loadMomentWithTzAndLocaleTa,
    te: loadMomentWithTzAndLocaleTe,
    tet: loadMomentWithTzAndLocaleTet,
    tg: loadMomentWithTzAndLocaleTg,
    th: loadMomentWithTzAndLocaleTh,
    tk: loadMomentWithTzAndLocaleTk,
    'tl-ph': loadMomentWithTzAndLocaleTlPh,
    tlh: loadMomentWithTzAndLocaleTlh,
    tr: loadMomentWithTzAndLocaleTr,
    tzl: loadMomentWithTzAndLocaleTzl,
    'tzm-latn': loadMomentWithTzAndLocaleTzmLatn,
    tzm: loadMomentWithTzAndLocaleTzm,
    'ug-cn': loadMomentWithTzAndLocaleUgCn,
    uk: loadMomentWithTzAndLocaleUk,
    ur: loadMomentWithTzAndLocaleUr,
    'uz-latn': loadMomentWithTzAndLocaleUzLatn,
    uz: loadMomentWithTzAndLocaleUz,
    vi: loadMomentWithTzAndLocaleVi,
    'x-pseudo': loadMomentWithTzAndLocaleXPseudo,
    yo: loadMomentWithTzAndLocaleYo,
    'zh-cn': loadMomentWithTzAndLocaleZhCn,
    'zh-hk': loadMomentWithTzAndLocaleZhHk,
    'zh-mo': loadMomentWithTzAndLocaleZhMo,
    'zh-tw': loadMomentWithTzAndLocaleZhTw,
  };
  if (!(locale in locales)) {
    return Promise.reject(new Error('Locale not found'));
  }
  return locales[locale]();
}

function loadMomentWithTz(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone'],
      () => {
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-en',
    );
  });
}

function loadMomentWithTzAndLocaleAf(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/af`],
      () => {
        require(`moment/locale/af`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-af',
    );
  });
}

function loadMomentWithTzAndLocaleArDz(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ar-dz`],
      () => {
        require(`moment/locale/ar-dz`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ar-dz',
    );
  });
}

function loadMomentWithTzAndLocaleArKw(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ar-kw`],
      () => {
        require(`moment/locale/ar-kw`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ar-kw',
    );
  });
}

function loadMomentWithTzAndLocaleArLy(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ar-ly`],
      () => {
        require(`moment/locale/ar-ly`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ar-ly',
    );
  });
}

function loadMomentWithTzAndLocaleArMa(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ar-ma`],
      () => {
        require(`moment/locale/ar-ma`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ar-ma',
    );
  });
}

function loadMomentWithTzAndLocaleArSa(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ar-sa`],
      () => {
        require(`moment/locale/ar-sa`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ar-sa',
    );
  });
}

function loadMomentWithTzAndLocaleArTn(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ar-tn`],
      () => {
        require(`moment/locale/ar-tn`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ar-tn',
    );
  });
}

function loadMomentWithTzAndLocaleAr(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ar`],
      () => {
        require(`moment/locale/ar`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ar',
    );
  });
}

function loadMomentWithTzAndLocaleAz(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/az`],
      () => {
        require(`moment/locale/az`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-az',
    );
  });
}

function loadMomentWithTzAndLocaleBe(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/be`],
      () => {
        require(`moment/locale/be`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-be',
    );
  });
}

function loadMomentWithTzAndLocaleBg(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/bg`],
      () => {
        require(`moment/locale/bg`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-bg',
    );
  });
}

function loadMomentWithTzAndLocaleBm(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/bm`],
      () => {
        require(`moment/locale/bm`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-bm',
    );
  });
}

function loadMomentWithTzAndLocaleBnBd(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/bn-bd`],
      () => {
        require(`moment/locale/bn-bd`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-bn-bd',
    );
  });
}

function loadMomentWithTzAndLocaleBn(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/bn`],
      () => {
        require(`moment/locale/bn`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-bn',
    );
  });
}

function loadMomentWithTzAndLocaleBo(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/bo`],
      () => {
        require(`moment/locale/bo`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-bo',
    );
  });
}

function loadMomentWithTzAndLocaleBr(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/br`],
      () => {
        require(`moment/locale/br`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-br',
    );
  });
}

function loadMomentWithTzAndLocaleBs(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/bs`],
      () => {
        require(`moment/locale/bs`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-bs',
    );
  });
}

function loadMomentWithTzAndLocaleCa(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ca`],
      () => {
        require(`moment/locale/ca`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ca',
    );
  });
}

function loadMomentWithTzAndLocaleCs(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/cs`],
      () => {
        require(`moment/locale/cs`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-cs',
    );
  });
}

function loadMomentWithTzAndLocaleCv(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/cv`],
      () => {
        require(`moment/locale/cv`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-cv',
    );
  });
}

function loadMomentWithTzAndLocaleCy(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/cy`],
      () => {
        require(`moment/locale/cy`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-cy',
    );
  });
}

function loadMomentWithTzAndLocaleDa(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/da`],
      () => {
        require(`moment/locale/da`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-da',
    );
  });
}

function loadMomentWithTzAndLocaleDeAt(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/de-at`],
      () => {
        require(`moment/locale/de-at`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-de-at',
    );
  });
}

function loadMomentWithTzAndLocaleDeCh(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/de-ch`],
      () => {
        require(`moment/locale/de-ch`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-de-ch',
    );
  });
}

function loadMomentWithTzAndLocaleDe(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/de`],
      () => {
        require(`moment/locale/de`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-de',
    );
  });
}

function loadMomentWithTzAndLocaleDv(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/dv`],
      () => {
        require(`moment/locale/dv`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-dv',
    );
  });
}

function loadMomentWithTzAndLocaleEl(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/el`],
      () => {
        require(`moment/locale/el`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-el',
    );
  });
}

function loadMomentWithTzAndLocaleEnAu(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/en-au`],
      () => {
        require(`moment/locale/en-au`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-en-au',
    );
  });
}

function loadMomentWithTzAndLocaleEnCa(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/en-ca`],
      () => {
        require(`moment/locale/en-ca`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-en-ca',
    );
  });
}

function loadMomentWithTzAndLocaleEnGb(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/en-gb`],
      () => {
        require(`moment/locale/en-gb`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-en-gb',
    );
  });
}

function loadMomentWithTzAndLocaleEnIe(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/en-ie`],
      () => {
        require(`moment/locale/en-ie`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-en-ie',
    );
  });
}

function loadMomentWithTzAndLocaleEnIl(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/en-il`],
      () => {
        require(`moment/locale/en-il`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-en-il',
    );
  });
}

function loadMomentWithTzAndLocaleEnIn(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/en-in`],
      () => {
        require(`moment/locale/en-in`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-en-in',
    );
  });
}

function loadMomentWithTzAndLocaleEnNz(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/en-nz`],
      () => {
        require(`moment/locale/en-nz`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-en-nz',
    );
  });
}

function loadMomentWithTzAndLocaleEnSg(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/en-sg`],
      () => {
        require(`moment/locale/en-sg`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-en-sg',
    );
  });
}

function loadMomentWithTzAndLocaleEo(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/eo`],
      () => {
        require(`moment/locale/eo`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-eo',
    );
  });
}

function loadMomentWithTzAndLocaleEsDo(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/es-do`],
      () => {
        require(`moment/locale/es-do`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-es-do',
    );
  });
}

function loadMomentWithTzAndLocaleEsMx(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/es-mx`],
      () => {
        require(`moment/locale/es-mx`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-es-mx',
    );
  });
}

function loadMomentWithTzAndLocaleEsUs(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/es-us`],
      () => {
        require(`moment/locale/es-us`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-es-us',
    );
  });
}

function loadMomentWithTzAndLocaleEs(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/es`],
      () => {
        require(`moment/locale/es`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-es',
    );
  });
}

function loadMomentWithTzAndLocaleEt(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/et`],
      () => {
        require(`moment/locale/et`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-et',
    );
  });
}

function loadMomentWithTzAndLocaleEu(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/eu`],
      () => {
        require(`moment/locale/eu`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-eu',
    );
  });
}

function loadMomentWithTzAndLocaleFa(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/fa`],
      () => {
        require(`moment/locale/fa`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-fa',
    );
  });
}

function loadMomentWithTzAndLocaleFi(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/fi`],
      () => {
        require(`moment/locale/fi`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-fi',
    );
  });
}

function loadMomentWithTzAndLocaleFil(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/fil`],
      () => {
        require(`moment/locale/fil`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-fil',
    );
  });
}

function loadMomentWithTzAndLocaleFo(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/fo`],
      () => {
        require(`moment/locale/fo`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-fo',
    );
  });
}

function loadMomentWithTzAndLocaleFrCa(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/fr-ca`],
      () => {
        require(`moment/locale/fr-ca`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-fr-ca',
    );
  });
}

function loadMomentWithTzAndLocaleFrCh(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/fr-ch`],
      () => {
        require(`moment/locale/fr-ch`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-fr-ch',
    );
  });
}

function loadMomentWithTzAndLocaleFr(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/fr`],
      () => {
        require(`moment/locale/fr`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-fr',
    );
  });
}

function loadMomentWithTzAndLocaleFy(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/fy`],
      () => {
        require(`moment/locale/fy`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-fy',
    );
  });
}

function loadMomentWithTzAndLocaleGa(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ga`],
      () => {
        require(`moment/locale/ga`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ga',
    );
  });
}

function loadMomentWithTzAndLocaleGd(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/gd`],
      () => {
        require(`moment/locale/gd`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-gd',
    );
  });
}

function loadMomentWithTzAndLocaleGl(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/gl`],
      () => {
        require(`moment/locale/gl`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-gl',
    );
  });
}

function loadMomentWithTzAndLocaleGomDeva(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/gom-deva`],
      () => {
        require(`moment/locale/gom-deva`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-gom-deva',
    );
  });
}

function loadMomentWithTzAndLocaleGomLatn(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/gom-latn`],
      () => {
        require(`moment/locale/gom-latn`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-gom-latn',
    );
  });
}

function loadMomentWithTzAndLocaleGu(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/gu`],
      () => {
        require(`moment/locale/gu`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-gu',
    );
  });
}

function loadMomentWithTzAndLocaleHe(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/he`],
      () => {
        require(`moment/locale/he`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-he',
    );
  });
}

function loadMomentWithTzAndLocaleHi(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/hi`],
      () => {
        require(`moment/locale/hi`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-hi',
    );
  });
}

function loadMomentWithTzAndLocaleHr(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/hr`],
      () => {
        require(`moment/locale/hr`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-hr',
    );
  });
}

function loadMomentWithTzAndLocaleHu(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/hu`],
      () => {
        require(`moment/locale/hu`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-hu',
    );
  });
}

function loadMomentWithTzAndLocaleHyAm(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/hy-am`],
      () => {
        require(`moment/locale/hy-am`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-hy-am',
    );
  });
}

function loadMomentWithTzAndLocaleId(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/id`],
      () => {
        require(`moment/locale/id`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-id',
    );
  });
}

function loadMomentWithTzAndLocaleIs(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/is`],
      () => {
        require(`moment/locale/is`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-is',
    );
  });
}

function loadMomentWithTzAndLocaleItCh(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/it-ch`],
      () => {
        require(`moment/locale/it-ch`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-it-ch',
    );
  });
}

function loadMomentWithTzAndLocaleIt(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/it`],
      () => {
        require(`moment/locale/it`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-it',
    );
  });
}

function loadMomentWithTzAndLocaleJa(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ja`],
      () => {
        require(`moment/locale/ja`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ja',
    );
  });
}

function loadMomentWithTzAndLocaleJv(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/jv`],
      () => {
        require(`moment/locale/jv`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-jv',
    );
  });
}

function loadMomentWithTzAndLocaleKa(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ka`],
      () => {
        require(`moment/locale/ka`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ka',
    );
  });
}

function loadMomentWithTzAndLocaleKk(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/kk`],
      () => {
        require(`moment/locale/kk`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-kk',
    );
  });
}

function loadMomentWithTzAndLocaleKm(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/km`],
      () => {
        require(`moment/locale/km`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-km',
    );
  });
}

function loadMomentWithTzAndLocaleKn(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/kn`],
      () => {
        require(`moment/locale/kn`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-kn',
    );
  });
}

function loadMomentWithTzAndLocaleKo(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ko`],
      () => {
        require(`moment/locale/ko`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ko',
    );
  });
}

function loadMomentWithTzAndLocaleKu(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ku`],
      () => {
        require(`moment/locale/ku`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ku',
    );
  });
}

function loadMomentWithTzAndLocaleKy(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ky`],
      () => {
        require(`moment/locale/ky`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ky',
    );
  });
}

function loadMomentWithTzAndLocaleLb(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/lb`],
      () => {
        require(`moment/locale/lb`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-lb',
    );
  });
}

function loadMomentWithTzAndLocaleLo(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/lo`],
      () => {
        require(`moment/locale/lo`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-lo',
    );
  });
}

function loadMomentWithTzAndLocaleLt(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/lt`],
      () => {
        require(`moment/locale/lt`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-lt',
    );
  });
}

function loadMomentWithTzAndLocaleLv(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/lv`],
      () => {
        require(`moment/locale/lv`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-lv',
    );
  });
}

function loadMomentWithTzAndLocaleMe(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/me`],
      () => {
        require(`moment/locale/me`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-me',
    );
  });
}

function loadMomentWithTzAndLocaleMi(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/mi`],
      () => {
        require(`moment/locale/mi`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-mi',
    );
  });
}

function loadMomentWithTzAndLocaleMk(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/mk`],
      () => {
        require(`moment/locale/mk`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-mk',
    );
  });
}

function loadMomentWithTzAndLocaleMl(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ml`],
      () => {
        require(`moment/locale/ml`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ml',
    );
  });
}

function loadMomentWithTzAndLocaleMn(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/mn`],
      () => {
        require(`moment/locale/mn`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-mn',
    );
  });
}

function loadMomentWithTzAndLocaleMr(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/mr`],
      () => {
        require(`moment/locale/mr`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-mr',
    );
  });
}

function loadMomentWithTzAndLocaleMsMy(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ms-my`],
      () => {
        require(`moment/locale/ms-my`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ms-my',
    );
  });
}

function loadMomentWithTzAndLocaleMs(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ms`],
      () => {
        require(`moment/locale/ms`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ms',
    );
  });
}

function loadMomentWithTzAndLocaleMt(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/mt`],
      () => {
        require(`moment/locale/mt`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-mt',
    );
  });
}

function loadMomentWithTzAndLocaleMy(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/my`],
      () => {
        require(`moment/locale/my`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-my',
    );
  });
}

function loadMomentWithTzAndLocaleNb(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/nb`],
      () => {
        require(`moment/locale/nb`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-nb',
    );
  });
}

function loadMomentWithTzAndLocaleNe(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ne`],
      () => {
        require(`moment/locale/ne`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ne',
    );
  });
}

function loadMomentWithTzAndLocaleNlBe(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/nl-be`],
      () => {
        require(`moment/locale/nl-be`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-nl-be',
    );
  });
}

function loadMomentWithTzAndLocaleNl(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/nl`],
      () => {
        require(`moment/locale/nl`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-nl',
    );
  });
}

function loadMomentWithTzAndLocaleNn(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/nn`],
      () => {
        require(`moment/locale/nn`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-nn',
    );
  });
}

function loadMomentWithTzAndLocaleOcLnc(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/oc-lnc`],
      () => {
        require(`moment/locale/oc-lnc`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-oc-lnc',
    );
  });
}

function loadMomentWithTzAndLocalePaIn(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/pa-in`],
      () => {
        require(`moment/locale/pa-in`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-pa-in',
    );
  });
}

function loadMomentWithTzAndLocalePl(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/pl`],
      () => {
        require(`moment/locale/pl`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-pl',
    );
  });
}

function loadMomentWithTzAndLocalePtBr(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/pt-br`],
      () => {
        require(`moment/locale/pt-br`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-pt-br',
    );
  });
}

function loadMomentWithTzAndLocalePt(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/pt`],
      () => {
        require(`moment/locale/pt`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-pt',
    );
  });
}

function loadMomentWithTzAndLocaleRo(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ro`],
      () => {
        require(`moment/locale/ro`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ro',
    );
  });
}

function loadMomentWithTzAndLocaleRu(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ru`],
      () => {
        require(`moment/locale/ru`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ru',
    );
  });
}

function loadMomentWithTzAndLocaleSd(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/sd`],
      () => {
        require(`moment/locale/sd`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-sd',
    );
  });
}

function loadMomentWithTzAndLocaleSe(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/se`],
      () => {
        require(`moment/locale/se`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-se',
    );
  });
}

function loadMomentWithTzAndLocaleSi(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/si`],
      () => {
        require(`moment/locale/si`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-si',
    );
  });
}

function loadMomentWithTzAndLocaleSk(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/sk`],
      () => {
        require(`moment/locale/sk`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-sk',
    );
  });
}

function loadMomentWithTzAndLocaleSl(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/sl`],
      () => {
        require(`moment/locale/sl`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-sl',
    );
  });
}

function loadMomentWithTzAndLocaleSq(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/sq`],
      () => {
        require(`moment/locale/sq`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-sq',
    );
  });
}

function loadMomentWithTzAndLocaleSrCyrl(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/sr-cyrl`],
      () => {
        require(`moment/locale/sr-cyrl`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-sr-cyrl',
    );
  });
}

function loadMomentWithTzAndLocaleSr(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/sr`],
      () => {
        require(`moment/locale/sr`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-sr',
    );
  });
}

function loadMomentWithTzAndLocaleSs(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ss`],
      () => {
        require(`moment/locale/ss`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ss',
    );
  });
}

function loadMomentWithTzAndLocaleSv(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/sv`],
      () => {
        require(`moment/locale/sv`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-sv',
    );
  });
}

function loadMomentWithTzAndLocaleSw(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/sw`],
      () => {
        require(`moment/locale/sw`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-sw',
    );
  });
}

function loadMomentWithTzAndLocaleTa(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ta`],
      () => {
        require(`moment/locale/ta`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ta',
    );
  });
}

function loadMomentWithTzAndLocaleTe(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/te`],
      () => {
        require(`moment/locale/te`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-te',
    );
  });
}

function loadMomentWithTzAndLocaleTet(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/tet`],
      () => {
        require(`moment/locale/tet`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-tet',
    );
  });
}

function loadMomentWithTzAndLocaleTg(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/tg`],
      () => {
        require(`moment/locale/tg`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-tg',
    );
  });
}

function loadMomentWithTzAndLocaleTh(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/th`],
      () => {
        require(`moment/locale/th`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-th',
    );
  });
}

function loadMomentWithTzAndLocaleTk(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/tk`],
      () => {
        require(`moment/locale/tk`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-tk',
    );
  });
}

function loadMomentWithTzAndLocaleTlPh(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/tl-ph`],
      () => {
        require(`moment/locale/tl-ph`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-tl-ph',
    );
  });
}

function loadMomentWithTzAndLocaleTlh(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/tlh`],
      () => {
        require(`moment/locale/tlh`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-tlh',
    );
  });
}

function loadMomentWithTzAndLocaleTr(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/tr`],
      () => {
        require(`moment/locale/tr`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-tr',
    );
  });
}

function loadMomentWithTzAndLocaleTzl(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/tzl`],
      () => {
        require(`moment/locale/tzl`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-tzl',
    );
  });
}

function loadMomentWithTzAndLocaleTzmLatn(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/tzm-latn`],
      () => {
        require(`moment/locale/tzm-latn`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-tzm-latn',
    );
  });
}

function loadMomentWithTzAndLocaleTzm(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/tzm`],
      () => {
        require(`moment/locale/tzm`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-tzm',
    );
  });
}

function loadMomentWithTzAndLocaleUgCn(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ug-cn`],
      () => {
        require(`moment/locale/ug-cn`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ug-cn',
    );
  });
}

function loadMomentWithTzAndLocaleUk(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/uk`],
      () => {
        require(`moment/locale/uk`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-uk',
    );
  });
}

function loadMomentWithTzAndLocaleUr(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/ur`],
      () => {
        require(`moment/locale/ur`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-ur',
    );
  });
}

function loadMomentWithTzAndLocaleUzLatn(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/uz-latn`],
      () => {
        require(`moment/locale/uz-latn`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-uz-latn',
    );
  });
}

function loadMomentWithTzAndLocaleUz(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/uz`],
      () => {
        require(`moment/locale/uz`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-uz',
    );
  });
}

function loadMomentWithTzAndLocaleVi(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/vi`],
      () => {
        require(`moment/locale/vi`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-vi',
    );
  });
}

function loadMomentWithTzAndLocaleXPseudo(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/x-pseudo`],
      () => {
        require(`moment/locale/x-pseudo`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-x-pseudo',
    );
  });
}

function loadMomentWithTzAndLocaleYo(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/yo`],
      () => {
        require(`moment/locale/yo`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-yo',
    );
  });
}

function loadMomentWithTzAndLocaleZhCn(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/zh-cn`],
      () => {
        require(`moment/locale/zh-cn`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-zh-cn',
    );
  });
}

function loadMomentWithTzAndLocaleZhHk(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/zh-hk`],
      () => {
        require(`moment/locale/zh-hk`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-zh-hk',
    );
  });
}

function loadMomentWithTzAndLocaleZhMo(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/zh-mo`],
      () => {
        require(`moment/locale/zh-mo`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-zh-mo',
    );
  });
}

function loadMomentWithTzAndLocaleZhTw(): Promise<any> {
  return new Promise((resolve, reject) => {
    require.ensure(
      ['moment-timezone', `moment/locale/zh-tw`],
      () => {
        require(`moment/locale/zh-tw`);
        resolve(require('moment-timezone'));
      },
      (err) => reject(err),
      'locale-zh-tw',
    );
  });
}
